import {
  SET_DELIVERY_STATUS,
  SET_PICKUP_STATUS,
  SET_PRODUCTION_STATUS
} from '../constants'

const initialState = {
  OverviewDeliveryData: {
    ExecutionTime: null
  },
  OverviewPickupData: {
    ExecutionTime: null
  },
  OverviewProductionData: {
    ExecutionTime: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DELIVERY_STATUS:
      return {
        ...state,
        OverviewDeliveryData: action.data
      }
    case SET_PICKUP_STATUS:
      return {
        ...state,
        OverviewPickupData: action.data
      }
    case SET_PRODUCTION_STATUS:
      return {
        ...state,
        OverviewProductionData: action.data
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/overview.js